import { ExtranetTicketListItemDto } from '@pharmac-extranet/extranet-api'
import {
  ExtranetContainer,
  ExtranetExpandArrowColumn,
  ExtranetTable,
  ExtranetTableColumn,
  ExtranetTableRow,
  useBreakpoint,
  useLanguage,
} from '@pharmac-extranet/shared'
import { PharmacButton, PharmacIcon, PharmacText } from '@pharmac/ui'
import { useMemo } from 'react'
import { useAuthenticationContext } from '../../features/authentication/useAuthentication'
import { TicketsListItem } from './TicketsListItem'

type TicketsTableProps = {
  startNewConversation: () => void
  tickets: ExtranetTicketListItemDto[]
}

export const TicketsTable = ({ startNewConversation, tickets }: TicketsTableProps) => {
  const { t } = useLanguage()
  const { minDesktop } = useBreakpoint()
  const { isPharmacCustomerService } = useAuthenticationContext()

  const sortedTickets = useMemo(
    () =>
      (tickets || []).sort((a, b) => {
        if (a.updated > b.updated) return -1
        if (a.updated < b.updated) return 1
        return 0
      }),
    [tickets]
  )

  return (
    <ExtranetContainer
      flexColumn
      full
    >
      <ExtranetContainer
        full
        flexRow
        justifyEnd
        paddingMediumTop
        paddingLargeBottom
        alignCenter
      >
        <PharmacButton
          marginSmallRight
          onClick={startNewConversation}
          disabled={isPharmacCustomerService}
        >
          <PharmacIcon
            size="18px"
            icon="plus"
          />
          <PharmacText paddingSmallHorizontal>
            {t('extranet:contact.startNewTicketButton')}
          </PharmacText>
        </PharmacButton>
      </ExtranetContainer>
      <ExtranetTable>
        <ExtranetTableRow
          style={{
            backgroundColor: 'var(--color-accent-4)',
            border: 'none',
            fontWeight: 600,
          }}
        >
          {minDesktop ? (
            <>
              <ExtranetTableColumn size={0.6}></ExtranetTableColumn>
              <ExtranetTableColumn
                marginSmallLeft
                size={1.5}
              >
                ID
              </ExtranetTableColumn>
              <ExtranetTableColumn size={4}>{t('extranet:contact.subject')}</ExtranetTableColumn>
              <ExtranetTableColumn size={2.5}>{t('extranet:contact.state')}</ExtranetTableColumn>
              <ExtranetTableColumn size={2.5}>
                {t('extranet:contact.createdAt')}
              </ExtranetTableColumn>
              <ExtranetTableColumn size={2.5}>
                {t('extranet:contact.updatedAt')}
              </ExtranetTableColumn>
              <ExtranetTableColumn size={4}>{t('extranet:contact.writer')}</ExtranetTableColumn>
            </>
          ) : (
            <>
              <ExtranetTableColumn size={0.6}></ExtranetTableColumn>
              <ExtranetTableColumn
                size={2}
                marginSmallLeft
              >
                {t('extranet:contact.state')}
              </ExtranetTableColumn>
              <ExtranetTableColumn size={2}>{t('extranet:contact.subject')}</ExtranetTableColumn>
            </>
          )}
          <ExtranetExpandArrowColumn />
        </ExtranetTableRow>
        {sortedTickets.map((ticket) => (
          <TicketsListItem
            key={ticket.id}
            ticket={ticket}
          />
        ))}
      </ExtranetTable>
    </ExtranetContainer>
  )
}
